import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAddressAutoUpdatedCount = {
  name: "getAddressAutoUpdatedCount" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
